(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bike-sticker-entry"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('.bs-studio-entry__button') : null;
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-kundenbikes"] && !Shopify.designMode) return;
  try {
    
function initBikeGalleries(root){
  root.querySelectorAll('.bs-kundenbikes').forEach(section=>{
    if(section.dataset.kbReady)return;
    section.dataset.kbReady='true';
    const dialog=section.querySelector('dialog');
    const photos=Array.from(section.querySelectorAll('[data-kb-photo]'));
    const full=dialog.querySelector('[data-kb-full]');
    let current=0;
    let opener;
    let previousOverflow;
    const show=index=>{current=(index+photos.length)%photos.length;full.src=photos[current].href;full.alt=photos[current].querySelector('img').alt;dialog.querySelector('[data-kb-counter]').textContent=`${current+1} / ${photos.length}`;};
    photos.forEach((photo,index)=>photo.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||typeof dialog.showModal!=='function')return;event.preventDefault();opener=photo;show(index);previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();}));
    dialog.querySelector('[data-kb-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-kb-prev]').addEventListener('click',()=>show(current-1));
    dialog.querySelector('[data-kb-next]').addEventListener('click',()=>show(current+1));
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(current-1);}if(event.key==='ArrowRight'){event.preventDefault();show(current+1);}});
    dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow||'';opener?.focus();});
  });
}
initBikeGalleries(document);
document.addEventListener('shopify:section:load',()=>initBikeGalleries(document));

  } catch(e) { console.error(e); }
})();
})();
